import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Auth, signOut } from "@angular/fire/auth";

/**
 * Guard that signs out the user when visiting the home page
 * This ensures users always start fresh on the home page
 */
export const signOutHomeGuard: CanActivateFn = async (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  // Sign out if user is authenticated
  if (auth.currentUser) {
    try {
      await signOut(auth);
      console.log("[SignOutHomeGuard] User signed out on home page visit");
    } catch (error) {
      console.error("[SignOutHomeGuard] Error signing out:", error);
      // Continue anyway - don't block navigation
    }
  }

  // Always allow access to home page
  return true;
};
